// src/components/SearchBar.jsx
import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Search, Clear as ClearIcon } from "@mui/icons-material";

const SearchBar = ({ searchTerms, setSearchTerms,setShowSearchfiled }) => {
  const handleChange = (e) => {
    setSearchTerms(e.target.value);
  };

  const handleClear = () => {
    setSearchTerms("");
    setShowSearchfiled(false)
  };

  return (
    <TextField
      sx={{
        background: "#fff",
        borderRadius: "10px",
        "& .MuiOutlinedInput-root": {
          "& fieldset": { borderColor: "transparent" },
          "&:hover fieldset": { borderColor: "#90CAF9" },
          "&.Mui-focused fieldset": { borderColor: "#1976D2" },
          "& input": {
            fontSize: "15px",
            color: "rgba(56, 79, 111, 1)",
          },
        },
      }}
      variant="outlined"
      fullWidth
      placeholder="Search Product"
      value={searchTerms}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: "rgba(56, 79, 111, 0.7)" }} />
          </InputAdornment>
        ),
        endAdornment: searchTerms && (
          <InputAdornment position="end">
            <IconButton onClick={handleClear} edge="end">
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
